import React from 'react';
export function SolutionSection() {
  return <section className="py-12 bg-main overflow-hidden" data-id="element-213">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-214">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-215">
          <div data-id="element-216">
            <p className="text-body text-base mb-6 leading-relaxed italic" data-id="element-217">
              No se trata de "hacerte influencer". Se trata de vender una
              estética + una solución con método, sin exposición.
            </p>

            <h2 className="text-3xl md:text-5xl font-serif mb-6 leading-tight text-title" data-id="element-218">
              Gana sin ser vista.
            </h2>
            <p className="text-body text-lg mb-4 leading-relaxed" data-id="element-219">
              Las cuentas que más crecen hoy no venden una persona. Venden una
              estética + una solución.
            </p>
            <p className="text-body text-lg mb-8 leading-relaxed" data-id="element-220">
              Sin mostrar tu cara, sin bailar y sin convertir tu vida privada en
              contenido.
            </p>
            <div className="p-6 bg-alt border-l-4 border-accent" data-id="element-221">
              <p className="font-serif text-lg italic text-title" data-id="element-222">
                "La era de vender tu vida privada terminó. Ahora gana quien
                tiene método."
              </p>
              <p className="mt-3 text-sm font-sans text-accent not-italic" data-id="element-223">
                — Método Faceless Spain
              </p>
            </div>

            <div className="mt-8" data-id="element-224">
              <p className="text-sm font-semibold text-title uppercase tracking-widest mb-4" data-id="element-225">
                Cómo funciona (en simple):
              </p>
              <ul className="space-y-3 text-body text-sm" data-id="element-226">
                <li className="flex items-start" data-id="element-227">
                  <span className="text-accent font-serif font-bold mr-3 mt-0.5" data-id="element-228">
                    1.
                  </span>
                  <span data-id="element-229">Eliges una estética y un ángulo (sin exponerte)</span>
                </li>
                <li className="flex items-start" data-id="element-230">
                  <span className="text-accent font-serif font-bold mr-3 mt-0.5" data-id="element-231">
                    2.
                  </span>
                  <span data-id="element-232">
                    Publicas contenido faceless (sin quedarte en blanco)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-233">
                  <span className="text-accent font-serif font-bold mr-3 mt-0.5" data-id="element-234">
                    3.
                  </span>
                  <span data-id="element-235">
                    Monetizas con una estructura clara (sin improvisar)
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="relative" data-id="element-236">
            <div className="space-y-8" data-id="element-237">
              <div className="bg-card p-8 border border-[#E7D8C8] relative" data-id="element-238">
                <span className="absolute -top-4 -left-4 w-10 h-10 bg-accent text-white flex items-center justify-center font-serif text-lg font-bold" data-id="element-239">
                  01
                </span>
                <h4 className="font-serif text-xl mb-2 text-title ml-4" data-id="element-240">
                  Anonimato que vende
                </h4>
                <p className="text-body text-sm ml-4" data-id="element-241">
                  Construyes una marca que funciona sin depender de tu imagen.
                </p>
              </div>

              <div className="bg-card p-8 border border-[#E7D8C8] relative ml-4 md:ml-8" data-id="element-242">
                <span className="absolute -top-4 -left-4 w-10 h-10 bg-accent text-white flex items-center justify-center font-serif text-lg font-bold" data-id="element-243">
                  02
                </span>
                <h4 className="font-serif text-xl mb-2 text-title ml-4" data-id="element-244">
                  Contenido faceless (simple y repetible)
                </h4>
                <p className="text-body text-sm ml-4" data-id="element-245">
                  Qué tipos de vídeos/fotos funcionan sin mostrar rostro y cómo
                  adaptarlos a tu estilo.
                </p>
              </div>

              <div className="bg-card p-8 border border-[#E7D8C8] relative ml-8 md:ml-16" data-id="element-246">
                <span className="absolute -top-4 -left-4 w-10 h-10 bg-accent text-white flex items-center justify-center font-serif text-lg font-bold" data-id="element-247">
                  03
                </span>
                <h4 className="font-serif text-xl mb-2 text-title ml-4" data-id="element-248">
                  Sistema que convierte
                </h4>
                <p className="text-body text-sm ml-4" data-id="element-249">
                  Perfil, mensajes y contenido alineados para que la gente
                  entienda, confíe y dé el siguiente paso.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}